"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (percentage) {
    return "rgba(42, 48, 82, " + percentage + ")";
};